import axios from "axios";
import { API_URL } from "../utils/constant";
import { toastr } from 'react-redux-toastr';
import { GET_QUESTIONNAIRES,GET_VENDOR_SERVICE_PROFILES, RISK_REGISTER, GET_CERTIFICATE_CRITICAL_FINDINGS, GET_CERTIFICATE_DATA_ACCESS, GET_CERTIFICATE_ASSESSMENT_HISTORY, GET_CERTIFICATE, VENDOR_RISK_REGISTER_QUESTION_BY_ID, RISK_REGISTER_VENDOR, RISK_REGISTER_QUESTION_BY_ID, REVIEW_RESPONSE, VENDOR_QUESTIONNAIRES_DASHBOARD, EMAIL_SUGGESTION, SHOWDETAILS_VENDOR_QUESTIONNAIRES_DASHBOARD, VENDOR_QUESTIONNAIRES_TOTAL, GET_QUESTIONNAIRES_BY_ID, SENT_QUESTIONNAIRES_TOTAL, SENT_QUESTIONNAIRES_DASHBOARD, GET_CERTIFICATE_ASSES } from "./index";
import { ResponsiveEmbed } from "react-bootstrap";

export const getQuestioner = (props, dispatch, isDraft, search, page, categoryName) => {
    const session = localStorage.getItem("session");
    axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
    axios
        .get(`${API_URL}/tprm/${props}/questioner-forms?isDraft=${isDraft}&formTitleQuery=${search}&page=${page}&isGeneralQuestionnaire=${categoryName}`,)
        .then((response) => {
            dispatch({
                type: GET_QUESTIONNAIRES,
                payload: response.data,
            });
        })
        .catch((err) => {
            var message = "Some server error has occurred.";
            if (err.response) {
                message = err.response.data.userMessage;
            }
        });
};

export const emailSuggestion = (props, dispatch, thirdPartyOrganisationId, emailQuery) => {
    const session = localStorage.getItem("session");
    axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
    axios
        .get(`${API_URL}/tprm/${props}/questioner/suggest-respondent-users?thirdPartyOrganisationId=${thirdPartyOrganisationId}&emailQuery=${emailQuery}`,)
        .then((response) => {
            dispatch({
                type: EMAIL_SUGGESTION,
                payload: response.data,
            });
        })
        .catch((err) => {
            var message = "Some server error has occurred.";
            if (err.response) {
                message = err.response.data.userMessage;
            }
        });
};

export const sentQuestionerDashboard = (props, dispatch, page, search, from, to, status = '', pageSize = 10, ids) => {
    const session = localStorage.getItem("session");
    axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
    axios
        .get(
            `${API_URL}/tprm/${props}/questioner/sent?page=${page}&formTitleQuery=${search}&from=${from}&to=${to}&status=${status}&limit=${pageSize}search?ids=${ids}`,
        )
        .then((response) => {
            dispatch({
                type: SENT_QUESTIONNAIRES_DASHBOARD,
                payload: response.data,
            });
        })
        .catch((err) => {
            var message = "Some server error has occurred.";
            if (err.response) {
                message = err.response.data.userMessage;
            }
        });
};

export const vendorQuestionerDashboard = (props, dispatch, page, search, from, to, status) => {
    const session = localStorage.getItem("session");
    axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
    axios
        .get(`${API_URL}/tprm/${props}/question-forms?page=${page}&formTitleQuery=${search}&from=${from}&to=${to}&status=${status}`,)
        .then((response) => {
            dispatch({
                type: VENDOR_QUESTIONNAIRES_DASHBOARD,
                payload: response.data,
            });
        })
        .catch((err) => {
            var message = "Some server error has occurred.";
            if (err.response) {
                message = err.response.data.userMessage;
            }
        });
};

export const showDetailsvendorQuestioner = (props, dispatch, id, page) => {
    const session = localStorage.getItem("session");
    axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
    axios
        .get(`${API_URL}/tprm/${props}/question-forms/${id}?page=${page || 1}`,)
        .then((response) => {
            dispatch({
                type: SHOWDETAILS_VENDOR_QUESTIONNAIRES_DASHBOARD,
                payload: response.data,
            });
        })
        .catch((err) => {
            var message = "Some server error has occurred.";
            if (err.response) {
                message = err.response.data.userMessage;
            }
        });
};

export const riskRegisterQuestionById = (props, dispatch, id, catId, quesId, page) => {
    const session = localStorage.getItem("session");
    axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
    axios
        .get(`${API_URL}/tprm/${props}/question-forms/${id}/categories/${catId}/questions/${quesId}?page=${page}`,)
        .then((response) => {
            dispatch({
                type: RISK_REGISTER_QUESTION_BY_ID,
                payload: response.data,
            });
        })
        .catch((err) => {
            var message = "Some server error has occurred.";
            if (err.response) {
                message = err.response.data.userMessage;
            }
        });
};

export const uploadCertificate = (data, dispatch, id) => {
    const session = localStorage.getItem("session");
    axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
    axios
        .post(`${API_URL}/risk-meta-data`, data)
        .then((response) => {
            if (response.data.error == false) {
                toastr.success("Success", response.data.userMessage);
                getCertificate(id, dispatch, 1, 10);
            } else {
                toastr.error("Error", response.data.userMessage);
            }
        }).catch((err) => {
            var message = "Some server error has occurred.";
            if (err.response) {
                message = err.response.data.userMessage;
            }
        });
};

export const uploadCertificateupdate = (id, props, dispatch, orgId) => {
    const session = localStorage.getItem("session");
    axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
    axios
        .put(`${API_URL}/risk-meta-data/${id}`, props)
        .then((response) => {
            if (response.data.error == false) {
                getCertificate(id, dispatch, 1, 10);
                toastr.success("Success", response.data.userMessage);
            } else {
                toastr.error("Error", response.data.userMessage);
            }
        }).catch((err) => {
            var message = "Some server error has occurred.";
            if (err.response) {
                message = err.response.data.userMessage;
            }
        });
};

export const getCertificate = (props, dispatch, page, limit) => {
    const session = localStorage.getItem("session");
    axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
    axios
        .get(`${API_URL}/risk-meta-data/organisation/${props}?page=${page}&limit=${limit}`,)
        .then((response) => {
            dispatch({
                type: GET_CERTIFICATE,
                payload: response.data,
            });
        }).catch((err) => {
            var message = "Some server error has occurred.";
            if (err.response) {
                message = err.response.data.userMessage;
            }
        });
};

export const getCertificateSubOrg = (props, subOrgId, dispatch, search) => {
    const session = localStorage.getItem("session");
    axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
    axios
        .get(`${API_URL}/organisations/${props}/forestview-clients/${subOrgId}/security-policy-files?name=${search || ''}`,)
        .then((response) => {
            dispatch({
                type: GET_CERTIFICATE,
                payload: response.data,
            });
        }).catch((err) => {
            var message = "Some server error has occurred.";
            if (err.response) {
                message = err.response.data.userMessage;
            }
        });
};

export const getCertificateAssessmentHistory = (props, subOrgId, dispatch) => {
    const session = localStorage.getItem("session");
    axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
    axios
        .get(`${API_URL}/tprm/${props}/questioner/sent/sub-org/${subOrgId}/vendor-profile/assessment-history`,)
        .then((response) => {
            dispatch({
                type: GET_CERTIFICATE_ASSESSMENT_HISTORY,
                payload: response.data,
            });
        }).catch((err) => {
            var message = "Some server error has occurred.";
            if (err.response) {
                message = err.response.data.userMessage;
            }
        });
};

export const getCertificateDataAccess = (props, subOrgId, dispatch) => {
    const session = localStorage.getItem("session");
    axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
    axios
        .get(`${API_URL}/organisation/${props}/suborganisation/${subOrgId}/vendor-profile/data-access`,)
        .then((response) => {
            dispatch({
                type: GET_CERTIFICATE_DATA_ACCESS,
                payload: response.data,
            });
        }).catch((err) => {
            var message = "Some server error has occurred.";
            if (err.response) {
                message = err.response.data.userMessage;
            }
        });
};

export const getCertificateFindingsCritical = (props, subOrgId, dispatch) => {
    const session = localStorage.getItem("session");
    axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
    axios
        .get(`${API_URL}/risk-questions/${props}/sub-org/${subOrgId}/vendor-profile/critical-findings`,)
        .then((response) => {
            dispatch({
                type: GET_CERTIFICATE_CRITICAL_FINDINGS,
                payload: response.data,
            });
        }).catch((err) => {
            var message = "Some server error has occurred.";
            if (err.response) {
                message = err.response.data.userMessage;
            }
        });
};

export const requestPrivatePolicy = (props, dispatch, data, subOrgId) => {
    const session = localStorage.getItem("session");
    axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
    axios
        .post(`${API_URL}/tprm/request-private-policy`, data)
        .then((response) => {
            if (response.data.error == false) {
                toastr.success("Success", response.data.userMessage);
                getCertificateSubOrg(props, subOrgId, dispatch);
            } else {
                toastr.error("Error", response.data.userMessage);
            }
        }).catch((err) => {
            var message = "Some server error has occurred.";
            if (err.response) {
                message = err.response.data.userMessage;
                toastr.error("Error", message);
            }
        });
};

export const riskRegisterVendorQuestionById = (props, dispatch, id, catId, quesId, page) => {
    const session = localStorage.getItem("session");
    axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
    axios
        .get(`${API_URL}/tprm/third-party-clients/${props}/question-forms/${id}/categories/${catId}/questions/${quesId}`,)
        .then((response) => {
            dispatch({
                type: VENDOR_RISK_REGISTER_QUESTION_BY_ID,
                payload: response.data,
            });
        })
        .catch((err) => {
            var message = "Some server error has occurred.";
            if (err.response) {
                message = err.response.data.userMessage;
            }
        });
};

export const reviewResponse = (props, dispatch, id, page, flagged) => {
    const session = localStorage.getItem("session");
    axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
    axios
        .get(`${API_URL}/tprm/vendors/${props}/question-forms/${id}?page=${page}&onlyFlaggedAsRisk=${flagged}`,)
        .then((response) => {
            dispatch({
                type: REVIEW_RESPONSE,
                payload: response.data,
            });
        })
        .catch((err) => {
            var message = "Some server error has occurred.";
            if (err.response) {
                message = err.response.data.userMessage;
            }
        });
};

export const saveQuestion = (props, id, data, handleRouteChange) => {
    const session = localStorage.getItem("session");
    axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
    axios
        .post(`${API_URL}/tprm/${props}/question-forms/${id}/submit`)
        .then((response) => {
            if (response.data.error == false) {
                toastr.success("Success", response.data.userMessage);
                handleRouteChange()
            } else {
                toastr.error("Error", response.data.userMessage);
            }
        })
        .catch((err) => {
            var message = "Some server error has occurred.";
            if (err.response) {
                message = err.response.data.userMessage;
            }
        });
};

export const approveReview = (props, id, data, handleRouteChange) => {
    const session = localStorage.getItem("session");
    axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
    axios
        .post(`${API_URL}/tprm/${props}/question-forms/${id}/approve`)
        .then((response) => {
            if (response.data.error == false) {
                toastr.success("Success", response.data.userMessage);
                handleRouteChange()
            } else {
                toastr.error("Error", response.data.userMessage);
            }
        })
        .catch((err) => {
            var message = "Some server error has occurred.";
            if (err.response) {
                message = err.response.data.userMessage;
            }
        });
};

export const rejectReview = (props, id, data, handleRouteChange) => {
    const session = localStorage.getItem("session");
    axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
    axios
        .post(`${API_URL}/tprm/${props}/question-forms/${id}/remove-from-risk`, data)
        .then((response) => {
            if (response.data.error == false) {
                toastr.success("Success", response.data.userMessage);
                handleRouteChange()
            } else {
                toastr.error("Error", response.data.userMessage);
            }
        })
        .catch((err) => {
            var message = "Some server error has occurred.";
            if (err.response) {
                message = err.response.data.userMessage;
            }
        });
};

export const saveOnChange = (props, id, data, dispatch, page) => {
    const session = localStorage.getItem("session");
    axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
    axios
        .post(`${API_URL}/tprm/${props}/question-forms/${id}/save-response`, data)
        .then((response) => {
            if (response.data.error == false) {
                showDetailsvendorQuestioner(props, dispatch, id, page)
            } else {
                toastr.error("Error", response.data.userMessage);
            }
        })
        .catch((err) => {
            var message = "Some server error has occurred.";
            if (err.response) {
                message = err.response.data.userMessage;
            }
        });
};

export const addRiskRegister = (props, id, data, dispatch, closeModal) => {
    const session = localStorage.getItem("session");
    axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
    axios
        .post(`${API_URL}/tprm/${props}/question-forms/${id}/register-as-risk`, data)
        .then((response) => {
            if (response.data.error == false) {
                toastr.success("Success", response.data.userMessage);
                closeModal();
            } else {
                toastr.error("Error", response.data.userMessage);
            }
        })
        .catch((err) => {
            var message = "Some server error has occurred.";
            if (err.response) {
                message = err.response.data.userMessage;
            }
        });
};

export const uploadImageInChat = async (data) => {
    try {
        const session = localStorage.getItem("session");
        axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;

        const response = await axios.post(`${API_URL}/storage/s3/upload`, data);

        if (response.data.error === false) {
            return response.data;
        }
    } catch (err) {
        let message = "Some server error has occurred.";
        if (err.response) {
            message = err.response.data.userMessage;
        }
        throw new Error(message);
    }
};

export const deleteFileChat = async (f) => {
    try {
        const session = localStorage.getItem("session");
        axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;

        const response = await axios.delete(`${API_URL}/storage/s3/delete?fileKey=${f}`);
        if (response.data.error === false) {
            return response.data.data;
        }
    } catch (err) {
        let message = "Some server error has occurred.";
        if (err.response) {
            message = err.response.data.userMessage;
        }
        throw new Error(message);
    }
};

// New function for uploading evidence using the new API endpoint
export const uploadEvidence = async (organisationId, questionFormId, categoryId, questionId, formData) => {
    try {
        const session = localStorage.getItem("session");
        axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;

        const response = await axios.post(
            `${API_URL}/tprm/organisations/${organisationId}/question-forms/${questionFormId}/categories/${categoryId}/questions/${questionId}/evidences`,
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            }
        );

        if (response.data.error === false) {
            return response.data;
        } else {
            throw new Error(response.data.userMessage || "Upload failed");
        }
    } catch (err) {
        let message = "Some server error has occurred.";
        if (err.response) {
            message = err.response.data.userMessage || err.response.data.message || message;
        }
        throw new Error(message);
    }
};

// New function for deleting evidence using the new API endpoint
export const deleteEvidence = async (organisationId, questionFormId, categoryId, questionId, fileData) => {
    try {
        const session = localStorage.getItem("session");
        axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;

        const response = await axios.delete(
            `${API_URL}/tprm/organisations/${organisationId}/question-forms/${questionFormId}/categories/${categoryId}/questions/${questionId}/evidence`,
            {
                data: {
                    file: fileData
                }
            }
        );

        if (response.data.error === false) {
            return response.data;
        } else {
            throw new Error(response.data.userMessage || "Delete failed");
        }
    } catch (err) {
        let message = "Some server error has occurred.";
        if (err.response) {
            message = err.response.data.userMessage || err.response.data.message || message;
        }
        throw new Error(message);
    }
};

export const dashboardQuestionerTotal = (props, dispatch) => {
    const session = localStorage.getItem("session");
    axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
    axios
        .get(`${API_URL}/tprm/${props}/questioner/sent/stats`,)
        .then((response) => {
            dispatch({
                type: SENT_QUESTIONNAIRES_TOTAL,
                payload: response.data,
            });
        })
        .catch((err) => {
            var message = "Some server error has occurred.";
            if (err.response) {
                message = err.response.data.userMessage;
            }
        });
};

export const getAllRiskRegistor = (id, dispatch, page = 1, status = "", riskLevel = "", assigneeOrganisationName = "") => {
    const session = localStorage.getItem("session");
    axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;

    let url = `${API_URL}/tprm/${id}/question-forms/marked-as-risk?page=${page}`;

    // Add filters to URL if they exist
    if (status) url += `&status=${status}`;
    if (riskLevel) url += `&riskLevel=${riskLevel}`;
    if (assigneeOrganisationName) url += `&assigneeOrganisationName=${assigneeOrganisationName}`;

    axios
        .get(url)
        .then((res) => {
            dispatch({
                type: RISK_REGISTER,
                payload: res.data
            });
        })
        .catch((err) => {
        });
};

export const riskRegistorUpdate = (props, questionFormId, data, dispatch) => {
    const session = localStorage.getItem("session");
    axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
    axios.put(`${API_URL}/tprm/${questionFormId}/question-forms/marked-as-risk/update`, data)
        .then((response) => {
            if (response.data.error == false) {
                toastr.success("Success", response.data.userMessage);
                getAllRiskRegistor(props, dispatch, 1)
            } else {
                toastr.error("Error", response.data.userMessage);
            }
        })
        .catch((err) => {
            var message = "Some server error has occurred.";
            if (err.response) {
                message = err.response.data.userMessage;
            }
        });
};

export const getAllRiskRegistorVendor = (props, dispatch, page) => {
    const session = localStorage.getItem("session");
    axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
    axios
        .get(`${API_URL}/tprm/third-party-clients/${props}/question-forms/questions/marked-as-risk?page=${page}`,)
        .then((response) => {
            dispatch({
                type: RISK_REGISTER_VENDOR,
                payload: response.data,
            });
        })
        .catch((err) => {
            var message = "Some server error has occurred.";
            if (err.response) {
                message = err.response.data.userMessage;
            }
        });
};

export const removeRiskRegistor = (props, questionFormId, data, dispatch) => {
    const session = localStorage.getItem("session");
    axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
    axios
        .post(`${API_URL}/tprm/${props}/question-forms/${questionFormId}/remove-from-risk`, data)
        .then((response) => {
            if (response.data.error == false) {
                toastr.success("Success", response.data.userMessage);
                getAllRiskRegistor(props, dispatch, 1)
            } else {
                toastr.error("Error", response.data.userMessage);
            }
        })
        .catch((err) => {
            var message = "Some server error has occurred.";
            if (err.response) {
                message = err.response.data.userMessage;
            }
        });
};

export const removeRiskRegistorVendor = (props, questionFormId, data, dispatch) => {
    const session = localStorage.getItem("session");
    axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
    axios
        .post(`${API_URL}/tprm/${props}/question-forms/questions/${questionFormId}/remove-from-risk`, data)
        .then((response) => {
            if (response.data.error == false) {
                toastr.success("Success", response.data.userMessage);
                getAllRiskRegistorVendor(props, dispatch, 1)
            } else {
                toastr.error("Error", response.data.userMessage);
            }
        })
        .catch((err) => {
            var message = "Some server error has occurred.";
            if (err.response) {
                message = err.response.data.userMessage;
            }
        });
};

export const vendorDashboardQuestionerTotal = (props, dispatch) => {
    const session = localStorage.getItem("session");
    axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
    axios
        .get(`${API_URL}/tprm/${props}/question-forms/stats`,)
        .then((response) => {
            dispatch({
                type: VENDOR_QUESTIONNAIRES_TOTAL,
                payload: response.data,
            });
        })
        .catch((err) => {
            var message = "Some server error has occurred.";
            if (err.response) {
                message = err.response.data.userMessage;
            }
        });
};

export const getQuestionerById = (props, _id, dispatch) => {
    const session = localStorage.getItem("session");
    axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
    axios
        .get(`${API_URL}/tprm/${props}/questioner-forms/${_id}`,)
        .then((response) => {
            dispatch({
                type: GET_QUESTIONNAIRES_BY_ID,
                payload: response.data,
            });
        })
        .catch((err) => {
            var message = "Some server error has occurred.";
            if (err.response) {
                message = err.response.data.userMessage;
            }
        });
};

export const SendQuestionnaire = (props, data, handleRouteChange) => {
    const session = localStorage.getItem("session");
    axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
    axios
        .post(`${API_URL}/tprm/${props}/questioner/send`, data)
        .then((response) => {
            if (response.data.error == false) {
                toastr.success("Success", response.data.userMessage);
                handleRouteChange()
            } else {
                toastr.error("Error", response.data.userMessage);
            }
        })
        .catch((err) => {
            var message = "Some server error has occurred.";
            if (err.response) {
                message = err.response.data.userMessage;
            }
        });
};

export const SaveAnswer = (props, id, data, handleRouteChange) => {
    const session = localStorage.getItem("session");
    axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
    axios
        .post(`${API_URL}/tprm/${props}/question-forms/${id}/save-response`, data)
        .then((response) => {
            if (response.data.error == false) {
                toastr.success("Success", response.data.userMessage);
                handleRouteChange()
            } else {
                toastr.error("Error", response.data.userMessage);
            }
        })
        .catch((err) => {
            var message = "Some server error has occurred.";
            if (err.response) {
                message = err.response.data.userMessage;
            }
        });
};

export const createTemplateApi = (props) => {
    return new Promise((resolve, reject) => {
        const session = localStorage.getItem("session");
        axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
        axios
            .post(`${API_URL}/tprm/${props}/questioner-form/create-draft`, {})
            .then((response) => {
                localStorage.setItem("createTemplateId", response?.data?.data?._id);
                resolve(response?.data?.data?._id);
            })
            .catch((err) => {
                var message = "Some server error has occurred.";
                if (err.response) {
                    message = err.response.data.userMessage;
                }
                reject(message);
            });
    });
};

export const reminderApi = (props, id, dispatch) => {
    const session = localStorage.getItem("session");
    axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
    axios
        .post(`${API_URL}/tprm/${props}/questioner-forms/${id}/send-approval-reminder`)
        .then((response) => {
            if (response.data.error == false) {
                // sentQuestionerDashboard(props, dispatch, 1)
                toastr.success("Success", response.data.userMessage);
            } else {
                toastr.error("Error", response.data.userMessage);
            }
        })
        .catch((err) => {
            var message = "Some server error has occurred.";
            if (err.response) {
                message = err.response.data.userMessage;
            }
        });
};

export const deleteQuestionnaire = (props, id, dispatch) => {
    const session = localStorage.getItem("session");
    axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
    axios
        .delete(`${API_URL}/tprm/${props}/questioner-forms/${id}`)
        .then((response) => {
            if (response.data.error == false) {
                getQuestioner(props, dispatch, 'undefined', '', 1)
                toastr.success("Success", response.data.userMessage);
            } else {
                toastr.error("Error", response.data.userMessage);
            }
        })
        .catch((err) => {
            var message = "Some server error has occurred.";
            if (err.response) {
                message = err.response.data.userMessage;
            }
        });
};

export const saveDraft = (props, data, clearbutton, handleRouteChange) => {
    const session = localStorage.getItem("session");
    axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
    axios
        .put(`${API_URL}/tprm/${props}/questioner-form/save-draft`, data)
        .then((response) => {
            if (response.data.error == false) {
                toastr.success("Success", response.data.userMessage);
                clearbutton();
                handleRouteChange();
            } else {
                toastr.error("Error", response.data.userMessage);
            }
        })
        .catch((err) => {
            var message = "Some server error has occurred.";
            if (err.response) {
                message = err.response.data.userMessage;
            }
        });
};

export const publish = (props, data, clearbutton, handleRouteChange) => {
    const session = localStorage.getItem("session");
    axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
    axios
        .put(`${API_URL}/tprm/${props}/questioner-form/publish`, data)
        .then((response) => {
            if (response.data.error == false) {
                toastr.success("Success", response.data.userMessage);
                clearbutton()
                handleRouteChange()
            } else {
                toastr.error("Error", response.data.userMessage);
            }
        })
        .catch((err) => {
            var message = "Some server error has occurred.";
            if (err.response) {
                message = err.response.data.userMessage;
            }
        });
};

export const deleteDocument = (id, orgId, dispatch, page = 1, limit = 10) => {
    const session = localStorage.getItem("session");
    axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
    axios
        .delete(`${API_URL}/organisations/${orgId}/risk-meta-data/${id}`)
        .then((response) => {
            if (response.data.error === false) {
                getCertificate(orgId, dispatch, page, limit);
                toastr.success("Success", "Document deleted successfully");
            } else {
                toastr.error("Error", response.data.userMessage);
            }
        })
        .catch((err) => {
            var message = "Failed to delete document";
            if (err.response) {
                message = err.response.data.userMessage;
            }
            toastr.error("Error", message);
        });
};

export const bulkDeleteDocuments = (fileIds, orgId, dispatch, page = 1, limit = 10) => {
    const session = localStorage.getItem("session");
    axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
    axios
        .delete(`${API_URL}/organisations/${orgId}/risk-meta-data`, {
            data: { fileIds }
        })
        .then((response) => {
            if (response.data.error === false) {
                getCertificate(orgId, dispatch, page, limit);
                toastr.success("Success", `${fileIds.length} document(s) deleted successfully`);
            } else {
                toastr.error("Error", response.data.userMessage);
            }
        })
        .catch((err) => {
            var message = "Failed to delete documents";
            if (err.response) {
                message = err.response.data.userMessage;
            }
            toastr.error("Error", message);
        });
};

export const exportReviewResponse = (props, id) => {
    return new Promise((resolve, reject) => {
        const session = localStorage.getItem("session");
        axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
        axios
            .get(`${API_URL}/tprm/vendors/${props}/question-forms/${id}/excel`, {
                responseType: "blob"
            })
            .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", `Review_Response_${id}.xlsx`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
                resolve();
            })
            .catch((err) => {
                var message = "Some server error has occurred.";
                if (err.response) {
                    message = err.response.data.userMessage;
                }
                reject(message);
            });
    });
};

export const GET_RISK_DISTRIBUTION = "GET_RISK_DISTRIBUTION";

export const getRiskDistribution = (vendorId, dispatch) => {
    const session = localStorage.getItem("session");
    axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
    axios
        .get(`${API_URL}/forest-view/vendors/${vendorId}/risk-distribution`)
        .then((response) => {
            dispatch({
                type: GET_RISK_DISTRIBUTION,
                payload: response.data,
            });
        })
        .catch((err) => {
            var message = "Some server error has occurred.";
            if (err.response) {
                message = err.response.data.userMessage;
            }
            toastr.error("Error", message);
        });
};


export const getVendorServiceProfiles = (vendorId, dispatch) => {
    const session = localStorage.getItem("session");
    axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
    axios
        .get(`${API_URL}/tprm/vendors/${vendorId}/service-profiles`)
        .then((response) => {
            dispatch({
                type: GET_VENDOR_SERVICE_PROFILES,
                payload: response.data,
            });
        })
        .catch((err) => {
            var message = "Some server error has occurred.";
            if (err.response) {
                message = err.response.data.userMessage;
            }
            // console.error removed
        });
};
